/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Skills_Skill_Group_NameInputs */

const en_tables_skills_skill_group_name = /** @type {(inputs: Tables_Skills_Skill_Group_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill Group Name`)
};

const de_tables_skills_skill_group_name = /** @type {(inputs: Tables_Skills_Skill_Group_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill Gruppe Name`)
};

/**
* | output |
* | --- |
* | "Skill Group Name" |
*
* @param {Tables_Skills_Skill_Group_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_skills_skill_group_name = /** @type {((inputs?: Tables_Skills_Skill_Group_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Skills_Skill_Group_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_skills_skill_group_name(inputs)
	return de_tables_skills_skill_group_name(inputs)
});